module.exports = __webpack_public_path__ + "@/assets/img/periods-icon.305cc2ad.svg";